export const environment = {
    production: false,
    hmr: false,
    appConfig: 'appconfig.development.docker.json',
    // Elevate AI chat widget (testbed). Deployed environment - stays off.
    // Toggling `enabled` is the whole switch: false injects no script, no stylesheet, and renders
    // no element. See README "Elevate AI chat widget (testbed)".
    aiChat: {
        enabled: false,
        widgetUrl: 'https://happy-mushroom-06ce27e03.7.azurestaticapps.net/main.js',
        stylesUrl: 'https://happy-mushroom-06ce27e03.7.azurestaticapps.net/styles.css',
        serverUrl: 'https://elevate-ai-mcp.livelyriver-fcabbbda.southafricanorth.azurecontainerapps.io/'
    }
};
